import React from 'react';
import { Link } from 'react-router-dom';

const STROKE_WIDTH = 4.5;

export const Mark = ({ size = 28, color = '#CC8400', className = '' }) => (
  <svg
    viewBox="0 0 100 100"
    width={size}
    height={size}
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <polygon
      points="50,5 95,50 50,95 5,50"
      stroke={color}
      strokeWidth={STROKE_WIDTH}
      strokeLinejoin="round"
    />
    <polygon points="50,30 71,50 50,70 29,50" fill={color} />
  </svg>
);

const Logo = ({
  to = '/',
  size = 28,
  color = '#CC8400',
  textColor,
  showWordmark = true,
  className = '',
}) => {
  const resolvedTextColor = textColor || (color === '#CC8400' ? '#FAFAFA' : color);

  const content = (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <Mark size={size} color={color} />
      {showWordmark && (
        <span
          className="leading-none tracking-tight select-none"
          style={{ color: resolvedTextColor, fontSize: size * 0.78 }}
        >
          <span className="font-light">core</span>
          <span className="font-bold tracking-tighter">trade</span>
        </span>
      )}
    </span>
  );

  if (to) {
    return (
      <Link to={to} className="inline-flex items-center" aria-label="Core Trade">
        {content}
      </Link>
    );
  }
  return content;
};

export default Logo;
